// 检测是否为移动设备
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
) || ('ontouchstart' in window && window.innerWidth <= 1024);

/**
 * 游戏配置管理
 * 集中管理所有可配置参数
 */
export const Config = {
    // 拼图默认设置
    puzzle: {
        cols: 4,
        rows: 4,
        pieceSize: 80,
        tabSize: 0.2,      // 凸起大小比例 (相对于pieceSize)
        jitter: 0,         // 边缘随机抖动 (Debug: set to 0)
        seed: 1234
    },

    // 吸附设置
    snap: {
        threshold: 15,     // 吸附距离阈值（像素）
        enabled: true
    },

    // 旋转设置（移动端自动禁用）
    rotation: {
        enabled: !isMobile,
        snapAngle: 90,     // 旋转吸附角度
        snapThreshold: 10  // 角度吸附阈值
    },

    // 渲染设置
    renderer: {
        backgroundAlpha: 0,
        antialias: true,
        resolution: window.devicePixelRatio || 1
    },

    // UI设置
    ui: {
        controlPanelHeight: 60,
        primaryColor: 0x3498db,
        secondaryColor: 0x34495e
    },

    // 计时器设置
    timer: {
        enabled: true,
        countDown: false,  // true为倒计时模式
        initialTime: 0     // 倒计时初始时间（秒）
    },

    // 计分设置
    score: {
        snapBonus: 10,         // 每次正确吸附得分
        timeBonus: 1000,       // 时间奖励基数
        rotationPenalty: 1     // 每次旋转扣分
    },

    // 浮雕效果设置
    bevel: {
        enabled: true,         // 是否启用浮雕效果
        quality: 'low',       // 'auto' | 'high' | 'low' | 'none'
        autoThreshold: 200,    // 自动模式下，超过此数量切换为low质量
        shadowOffset: 0,       // 阴影偏移量（像素）
        shadowColor: 0x000000, // 阴影颜色
        shadowAlpha: 0.1,      // 阴影透明度
        highlightColor: 0xffffff, // 高光颜色
        highlightAlpha: 0.4,   // 高光透明度
        darkEdgeColor: 0x000000,  // 暗边颜色
        darkEdgeAlpha: 0.2     // 暗边透明度
    }
};

/**
 * 深度合并配置
 * @param {Object} target 目标配置
 * @param {Object} source 源配置
 * @returns {Object} 合并后的配置
 */
export function mergeConfig(target, source) {
    const result = { ...target };
    for (const key in source) {
        if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
            result[key] = mergeConfig(target[key] || {}, source[key]);
        } else {
            result[key] = source[key];
        }
    }
    return result;
}

export default Config;
